"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var SvgIconTSA = function SvgIconTSA(props) {
  return /*#__PURE__*/_react.default.createElement("svg", _extends({
    viewBox: "0 0 48 48",
    "aria-label": "t s a icon",
    fill: "currentColor",
    fillRule: "evenodd"
  }, props), /*#__PURE__*/_react.default.createElement("title", null, 'T S A Icon'), /*#__PURE__*/_react.default.createElement("path", {
    d: "M7 11.272L23.63 4l16.628 7.272v10.91c0 10.09-7.094 19.527-16.628 21.818C14.094 41.71 7 32.272 7 22.182v-10.91zm25.109 4.693L19.93 27.946l-4.781-4.69-2.606 2.564 7.387 7.27 14.784-14.544-2.605-2.581z"
  }));
};

var _default = SvgIconTSA;
exports.default = _default;